import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleUp, faAngleDown } from "@fortawesome/pro-regular-svg-icons";

import styles from "@@/styles/components/header/mobile/MobileNavItem.module.scss";

import { HEADER_CATEGORY } from "../Header";

import DropdownContent from "../DropdownContent";
import {JSX} from "react";

interface IMobileNavItemProps {
	title: string
	category: HEADER_CATEGORY
	onClick: CallableFunction
	onNavigate: CallableFunction
	toggled: boolean
}

export default function MobileNavItem(props: IMobileNavItemProps): JSX.Element {
	const { title, category, onClick, onNavigate, toggled, } = props;

	const [animation, setAnimation] = useState<string>("");

	useEffect(() => {
		setAnimation(toggled ? styles.slide_in : styles.slide_out);
	}, [toggled]);

	function clickHandler() {
		onClick(toggled ? undefined : category);
	}

	function navigateHandler() {
		onNavigate();
	}

	return (
		<>
			<div className={styles.main}  onTouchEnd={clickHandler}>
				<p>{title}</p>
				<FontAwesomeIcon icon={toggled ? faAngleUp : faAngleDown} />
			</div>

			<div className={`${styles.container} ${animation}`} onTouchEnd={navigateHandler}>
				<div className={styles.categories}>
					<DropdownContent />
				</div>
			</div>
		</>
	);
}
